/***
 * Created on 2025/5/6
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import {useTranslation} from "react-i18next";
import ic_content_site from '../../static/img/content/ic-content-site.svg';
import ic_illustration_cloud_space from '../../static/img/illustration/illustration-cloud-space.svg';

function CloudSpaceEmptyPageComponent(props) {
    const { t } = useTranslation();

    return (
        <div className="content content-page">
            <div className="content-wrapper page-wrapper">
                <div className="content-empty-screen">
                    <div className="empty-title-group !-mt-50">
                        <div className="empty-illustration"><img src={ic_illustration_cloud_space} /></div>
                    </div>
                    <div className="empty-devide"></div>
                    <div className="empty-desc !mt-24 !mb-24">
                        <div className="sub-title !font-normal">
                            <p>{t('@Organization Space is a cloud-based storage environment designed for teams using myQNAPcloud Storage for Business. It centralizes file storage, permission control, and user management—making it easier for teams to collaborate securely and efficiently.@')}
                                &nbsp;
                                <a href={`${window._env_.REACT_APP_Q2_PURCHASE_URL}`} target="_blank">{t('@Learn more@')}</a>
                            </p>
                        </div>
                    </div>
                    <button className="q-btn q-btn-primary q-btn-primary--focus q-btn-large"
                            onClick={()=>window.open(window._env_.REACT_APP_Q2_STARTER_URL, '_blank')}>
                        {t('@Get Started@')}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CloudSpaceEmptyPageComponent;